import { REGEX_ISO_8601_DATETIME } from '../utils/RegularExpressions'

//parses a json.net date string into a JavaScript Date object
export const deserializeJsonDotNetDate = (value) => {
    const dateRegex = /\/Date\((\d+)\+\d+\)\//;
    let result = ''
    if (!value) {
        return result
    }
    let match = value.match(dateRegex)
    if (match && match[1]) {
        return new Date(parseInt(match[1], 10))
    }
    return result
}

export const getDateMinus30DaysComputed = () => {
    const now = new Date(); // Current date and time
    const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000); // Subtract 30 days in milliseconds
    return thirtyDaysAgo.toISOString(); // Format as ISO string
}

export const digitalClock = (seconds) => {
    if (seconds < 0) {
        seconds = 0
    }
    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = Math.floor(seconds % 60)
    const addZero = function (number) {
        return (number < 10) ? '0' + number : '' + number
    }
    const formatHMS = function (h, m, s) {
        if (h > 0) {
            return `${h}:${addZero(m)}:${addZero(s)}`
        }
        return `${m}:${addZero(s)}`
    }
    return formatHMS(h, m, s)
}

export const parseDate = (date) => {
    let match = date.match(/\/Date\((\d+)\+\d+\)\//)
    if (match && match[1]) {
        date = deserializeJsonDotNetDate(date)
    } else {
        match = date.match(/^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(\.\d+)?$/)
        if (match) {
            //console.log("Date \"".concat(date).concat("\" is a mangled date time string"))
            date = date.concat("Z")
        }
        match = date.match(REGEX_ISO_8601_DATETIME)
        if (match) {
            //console.log("Date \"".concat(date).concat("\" is a JS date time string"))
            date = new Date(date)
        } else {
            throw Error("Input parameter is the unparseable string \"".concat(date).concat("\""))
        }
    }
    return date
}